import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { Document } from "@contentful/rich-text-types";

export const richTextToHTML = (richText: Document) => {
    let htmlString: string = documentToHtmlString(richText);

    htmlString = htmlString.replace(/\n/g, "<br />");

    return htmlString;
};
